import React, { useState } from 'react';

const Summary: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="summary-box">
      <h2 className="summary-title" onClick={toggleCollapse} style={{ cursor: 'pointer' }}>
        How to Use JSON-LD Editor
        <span style={{ marginLeft: '8px', fontSize: '0.8em' }}>
          {isCollapsed ? '▼' : '▲'}
        </span>
      </h2>
      
      {!isCollapsed && (
        <>
          <hr className="summary-line" />

          <p>
            This JSON-LD editor helps you create structured data markup using the Schema.org vocabulary. 
            JSON-LD (JavaScript Object Notation for Linked Data) is a way to embed structured data in web pages 
            that search engines and other applications can understand.
          </p>

          <p>
            Currently supports <a href="https://schema.org/" target="_blank" rel="noopener noreferrer">Schema.org</a> vocabulary 
            for creating rich snippets and enhanced search results.
          </p>
          
          <ol className="summary-list">
            <li>
              Start with Context<br/>
              The editor automatically sets <code className="summary-code-inline">@context</code> to <code className="summary-code-inline">"https://schema.org"</code>
            </li>
            <li>
              Choose Your Type<br/>
              Set <code className="summary-code-inline">@type</code> to specify what you're describing:
              <ul className="summary-list">
                <li>WebApplication, Article, Organization, Person, etc.</li>
                <li>Use the type-ahead suggestions for valid Schema.org types</li>
              </ul>
            </li>
            <li>
              Add Properties<br/>
              Click the "+" button to add properties like:
              <ul className="summary-list">
                <li><code className="summary-code-inline">name</code> - The name of your entity</li>
                <li><code className="summary-code-inline">description</code> - A description</li>
                <li><code className="summary-code-inline">url</code> - Website URL</li>
                <li><code className="summary-code-inline">author</code> - Creator information</li>
              </ul>
            </li>
            <li>
              Nested Objects & Arrays<br/>
              Create complex structures:
              <ul className="summary-list">
                <li>Objects for detailed information (e.g., author details)</li>
                <li>Arrays for multiple values (e.g., multiple authors)</li>
                <li>Convert between string, object, and array types</li>
              </ul>
            </li>
            <li>
              Export & Use<br/>
              <ul className="summary-list">
                <li>Click "Export JSON" to get your structured data</li>
                <li>Embed in your HTML using a <code className="summary-code-inline">&lt;script&gt;</code> tag</li>
                <li>Test with Google's <a href="https://search.google.com/test/rich-results" target="_blank" rel="noopener noreferrer">Rich Results Test</a></li>
              </ul>
            </li>
          </ol>

          <div className="summary-example">
            <h3>Example Usage in HTML:</h3>
            <pre className="summary-code-block"><code>{`<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@type": "WebApplication",
  "name": "My App",
  "description": "A useful web application",
  "url": "https://example.com",
  "author": {
    "@type": "Organization",
    "name": "My Company"
  }
}
</script>`}</code></pre>
          </div>
        </>
      )}
    </div>
  );
};

export default Summary; 